import React from 'react';

interface PipeBioTokenProps {
  pipebioTokenHint?: string;
  pipebioTokenExpiresAt?: string;
}

function PipeBioTokenSection({pipebioTokenHint, pipebioTokenExpiresAt}: PipeBioTokenProps): JSX.Element {
  const tokenTable = pipebioTokenHint ? (
    <table className="table table-striped pipebio-token-table">
      <thead>
        <tr>
          <th>Account Token</th>
          <th />
          <th />
          <th>Expires At</th>
          <th />
        </tr>
      </thead>
      <tbody className="pipebio-token">
        <tr>
          <td>{`• • • • • • • • ${pipebioTokenHint}`}</td>
          <td />
          <td />
          <td>{pipebioTokenExpiresAt}</td>
          <td />
        </tr>
      </tbody>
    </table>
  ) : null;

  return (
    <>
      <h3>Token</h3>
      {tokenTable}
      <button type="button" className="button button--tertiaryGray button--medium js-generate-pipebio-token">
        Generate New PipeBio Account Token
      </button>
    </>
  );
}

export default function ProfilePipeBioIntegrationSettings(pipebioTokenProps: PipeBioTokenProps): JSX.Element {
  return (
    <>
      <h2 id="pipebio-integration">PipeBio Integration</h2>
      <PipeBioTokenSection {...pipebioTokenProps} />
      <h3>Information</h3>
      <div>
        Copy this token into your PipeBio profile so actions you take in PipeBio can be linked to this
        Benchling account.{' '}
        <a
          title="PipeBio token documentation"
          href="" // TODO: add link
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
        .
      </div>
    </>
  );
}
